import { forwardRef } from "react";
function SvgRawCheckCircleFilled({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <circle
        cx={16}
        cy={16}
        r={12}
        fill="#1D1D1D"
        stroke="#1D1D1D"
        strokeWidth={2}
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M20 11c-3.556 4.075-5 9-5 9l-3-4"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawCheckCircleFilled);
export default ForwardRef;
